<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="submission">
            <CategorySelector
                v-if="matching_taxonomies.length"
                :categories="matching_taxonomies"
            />

            <div v-for="category in matching_taxonomies">
                <div v-if="category.id == submission.category_id">
                    <SubCategorySelector
                        v-if="category.sub_categories.length"
                        :sub_categories="category.sub_categories"
                    />

                    <SubSubCategorySelector
                        v-if="subSubCategoriesUnderSelectedSubCategory(category).length"
                        :sub_sub_categories="subSubCategoriesUnderSelectedSubCategory(category)"
                    />

                    <GenresSelector
                        v-if="category.genres.length"
                        :genres="category.genres"
                    />

                    <ThemesSelector
                        v-if="category.themes.length"
                        :themes="category.themes"
                    />
                </div>
            </div>
        </div>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import CategorySelector from "./partials/CategorySelector.vue";
import SubCategorySelector from "./partials/SubCategorySelector.vue";
import SubSubCategorySelector from "./partials/SubSubCategorySelector.vue";
import GenresSelector from "./partials/GenresSelector.vue";
import ThemesSelector from "./partials/ThemesSelector.vue";

import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState, mapActions } from "pinia";

export default {
    mixins: [validationMixin],

    components: {
        CategorySelector,
        SubCategorySelector,
        SubSubCategorySelector,
        GenresSelector,
        ThemesSelector,
    },

    computed: {
        ...mapState(useSubmissionWizardStore, [
            "company_id",
            "has_loaded_matching_taxonomies",
            "matching_taxonomies",
            "matching_themes",
        ]),
        ...mapWritableState(useSubmissionWizardStore, [
            "presentation",
            "submission",
            "bottom_navigation_rules",
        ]),
        isValid() {
            if (!this.submission) return false;
            if (this.submission) {
                if (!this.submission.category_id) return false;
            }
            return true;
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["loadEntryPointTaxonomies"]),

        subSubCategoriesUnderSelectedSubCategory(category) {
            let result = category.sub_categories.find(
                (taxonomy) => taxonomy.id === this.submission.sub_category_id,
            );

            if (result && result.sub_sub_categories)
                return result.sub_sub_categories;

            return [];
        },
    },

    mounted() {
        var self = this;
        setTimeout(function () {
            if (!self.has_loaded_matching_taxonomies) {
                self.loadEntryPointTaxonomies();
            }
        }, 300);
    },
};
</script>
